var _NotifyUserCommand_socket;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
export class NotifyUserCommand {
    constructor(socket) {
        _NotifyUserCommand_socket.set(this, void 0);
        __classPrivateFieldSet(this, _NotifyUserCommand_socket, socket, "f");
    }
    execute(privateKey, userHash) {
        __classPrivateFieldGet(this, _NotifyUserCommand_socket, "f").send({
            commandType: 'notify-user',
            resource: { from: privateKey, to: userHash },
        });
    }
}
_NotifyUserCommand_socket = new WeakMap();
